import { md5 } from "js-md5";
import { Base64 } from "js-base64";
import moment from "moment";
import useUserStore from "@/stores/user";
import { ApiPerson } from "@/api/person";

const getUserToken = () => {
  const userStore = useUserStore();
  return userStore.token || localStorage.getItem("AI-Token") || "";
};

// 处理加密参数  post  方法
export const signData = (data: any) => {
  const appId = "JKapLf72FJyaNLs8";
  const appSecret = "m7TsMCtH@ryQKrCGhLv#CpA3utSz596G";
  const dataString = JSON.stringify(data);
  const timestamp = moment().format("x");
  const signString =
    appId +
    ":" +
    dataString +
    ":" +
    timestamp +
    ":" +
    appSecret +
    ":" +
    getUserToken();
  const sign = md5(Base64.encode(signString));
  const params = `sign=${sign}&timestamp=${timestamp}&appId=${appId}&`;
  return params;
};
// 处理加密参数  get  方法
export const objectToSortedString = (obj: Record<string, any> = {}) => {
  const appId = "JKapLf72FJyaNLs8";
  const appSecret = "m7TsMCtH@ryQKrCGhLv#CpA3utSz596G";
  let result = "";
  let queryParams = "";

  if (Object.keys(obj).length !== 0) {
    const sortedKeys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
    result = sortedKeys.map((key) => `${key}${obj[key]}`).join("");
    queryParams = sortedKeys.map((key) => `${key}=${obj[key]}`).join("&");
  }

  const timestamp = moment().format("x");
  const token = localStorage.getItem("AI-Token");
  const signString = `${appId}:${result}:${timestamp}:${appSecret}:${token}`;
  const sign = md5(Base64.encode(signString));
  const params = queryParams
    ? `${queryParams}&sign=${sign}&timestamp=${timestamp}&appId=${appId}`
    : `sign=${sign}&timestamp=${timestamp}&appId=${appId}`;

  return params;
};
export const multiplyWithoutRounding = (
  left: number | string,
  right: number | string
) => {
  const value = Number(left || 0) * Number(right || 0);

  if (!Number.isFinite(value)) {
    return 0;
  }

  const [integerPart, decimalPart = ""] = String(value).split(".");

  if (!decimalPart) {
    return Number(integerPart);
  }

  return Number(`${integerPart}.${decimalPart.slice(0, 4)}`);
};

export const axiosUploadFile = async (
  file: any,
  tips: boolean = true
): Promise<string | null> => {
  const formData = new FormData();
  formData.append("file", file);
  const appId = "JKapLf72FJyaNLs8";
  const timestamp = moment().format("x");
  const userToken = getUserToken();
  const sign = md5(
    Base64.encode(
      `${appId}::${timestamp}:m7TsMCtH@ryQKrCGhLv#CpA3utSz596G:${userToken}`
    )
  );
  formData.append("appId", appId);
  formData.append("timestamp", timestamp);
  formData.append("sign", sign);
  try {
    const response: any = await ApiPerson.upImg(formData);
    if (response.code === 200) {
      if (tips) {
        ElMessage.success("上传成功");
      }
      return response.data.fileUrl; // 返回上传的文件 URL
    } else {
      ElMessage.error(response.msg);
      return null;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    ElMessage.error("上传出错");
    return null;
  }
};

export const urlToVideoFile = async(url: any, filename?: any) => {
  try {
      // 第一步：使用 fetch 获取视频数据
      const response = await fetch(url);
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob(); // 第二步：创建 Blob 对象
      const file = new File([blob], filename, {
          type: blob.type, // 指定文件类型，例如 'video/mp4'
          lastModified: Date.now() // 设置文件的最后修改时间为当前时间
      }); // 第三步：创建 File 对象
      return file;
  } catch (error) {
      console.error('Failed to convert URL to File:', error);
      return null;
  }
}
